// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/login.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Write your custom CSS here */
.MuiBackdrop-root {
  background-color: rgba(0, 0, 0, 0.5) !important;
}

::-webkit-scrollbar {
  height: 1px;
  /* height of horizontal scrollbar ← You're missing this */
  width: 8px;
  /* width of vertical scrollbar */
  border: 1px solid #d5d5d5;
}

::-webkit-scrollbar-track {
  background: #181821;
}

::-webkit-scrollbar-thumb {
  background: #e8538f;
}

.page-sidebar .accordion-menu::-webkit-scrollbar {
  height: 0px;
  /* height of horizontal scrollbar ← You're missing this */
  width: 4px;
  /* width of vertical scrollbar */
  border: 1px solid #d5d5d5;
}

.collapse::-webkit-scrollbar {
  height: 0px;
  /* height of horizontal scrollbar ← You're missing this */
  width: 2px;
  /* width of vertical scrollbar */
  border: 1px solid #d5d5d5;
}

.followDiv::-webkit-scrollbar {
  height: 0px;
  /* height of horizontal scrollbar ← You're missing this */
  width: 3px;
  /* width of vertical scrollbar */
  border: 1px solid #d5d5d5;
}

.css-jtlhu6-MuiTablePagination-root {
  overflow: auto;
  color: white;
  font-size: 0.875rem;
}

.image {
  opacity: 1;
  display: block;
  width: 38%;
  height: auto;
  transition: 0.5s ease;
  backface-visibility: hidden;
}

.middle {
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.container:hover .image {
  opacity: 0.6;
  cursor: grab;
}

.container:hover .middle {
  opacity: 1;
}

.page-sidebar .accordion-menu > li > span {
  display: block;
  color: #9a9cab;
  transition: all 0.1s ease-in-out;
  line-height: 45px;
  padding: 0 15px;
  text-decoration: none;
  cursor: pointer;
}

.page-sidebar .accordion-menu > li > span > svg {
  width: 21px;
  height: 21px;
  line-height: 40px;
  text-align: center;
  vertical-align: text-top;
  color: #9a9cab;
  margin-right: 15px;
  transition: all 0.2s ease-in-out;
}

.sidenav__icon {
  margin-right: 15px;
}

.card-overflow {
  overflow-x: scroll;
}

.card-overflow::-webkit-scrollbar {
  height: 1px;
  /* height of horizontal scrollbar ← You're missing this */
  width: 3px;
  /* width of vertical scrollbar */
  border: 1px solid #d5d5d5;
}

.card-overflow::-webkit-scrollbar-track {
  background: #181821;
}

.card-overflow::-webkit-scrollbar-thumb {
  background: #1f1f2b;
}

.back__style {
  width: "100%";
  height: "100%";
  background-size: "cover";
  background-attachment: "fixed";
  margin: 0;
  padding: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.icon_margin {
  margin-left: 5px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 58px;
  height: 32px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #86c1ed;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 24px;
  width: 24px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #ada6f2;
}

input:focus + .slider {
  box-shadow: 0 0 1px #ada6f2;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

.searchBar:focus {
  background-color: #1f1f2b;
  box-shadow: none;
}

.MuiTypography-colorInherit {
  color: #91a3b0 !important;
}

.MuiSelect-select {
  color: #91a3b0 !important;
}

.MuiSelect-icon {
  color: #91a3b0 !important;
}

.MuiIconButton-root.Mui-disabled {
  color: #9a9cab !important;
}

.MuiIconButton-root {
  color: #86c1ed !important;
}

.float__right {
  float: right;
}

.MuiPaper-root {
  background-color: #161622 !important;
}

.text-gray {
  color: #91a3b0;
}

.text-red {
  color: #de1738;
}

.collapse-margin {
  margin-left: -7px;
  /* overflow-x: scroll; */
}

.pointer-cursor {
  cursor: pointer;
}

audio::-webkit-media-controls-play-button,
audio::-webkit-media-controls-panel {
  background-color: aliceblue;
  color: #fff;
}

.post-padding {
  padding: 6px 15px !important;
  margin-bottom: 0;
}

.commentImg {
  margin-top: 13px;
}

.shadow {
  box-shadow: rgb(105 103 103 / 50%) 0px 5px 15px 0px;
  border: 2px solid #e8538f;
}

.comment-delete {
  margin-left: 10px;
}

.form-check-input:focus,
.form-control:focus {
  box-shadow: none;
}

.rows > * {
  max-height: 500px;
}

.pie > * {
  max-height: 350px;
}

.swal-title {
  color: rgba(255, 255, 255, 0.65) !important;
  font-weight: 500 !important;
}

.swal-text {
  color: rgba(255, 255, 255, 0.64) !important;
}

.swal-modal {
  background-color: #161622 !important;
}

.swal-icon--success__hide-corners,
.swal-icon--success:after,
.swal-icon--success:before {
  background-color: transparent;
}

.MuiSelect-select:not([multiple]) option,
.MuiSelect-select:not([multiple]) optgroup {
  background-color: #161622 !important;
}

.chip,
.highlightOption,
.multiSelectContainer li:hover {
  background: #e8538f !important;
}

.page-sidebar .accordion-menu {
  overflow-x: scroll !important;
}

.danger {
  background-color: #f5365c;
}

.success {
  background-color: #146356;
}

.stats-card .stats-icon.change-pink {
  color: #fff;
  background-color: #fc9494;
  box-shadow: 0 3px 18px -8px #fc9494;
}

.border-right-radius {
  border-top-right-radius: 50rem;
  border-bottom-right-radius: 50rem;
}

.pagination {
  /* float: right; */
}

.page-link {
  border-radius: 50% !important;
  padding: 5px 13px;
}

.page-item {
  padding: 5px;
}

.page-item.active .page-link {
  z-index: 1;
  color: #fff !important;
  background-color: #e8538f;
  border-color: #e8538f;
}

.page-link:focus {
  box-shadow: none;
}

.dropdown {
  max-height: 30px;
  margin-top: 15px;
  padding: 3px 5px;
  font-size: 12px;
  max-width: 80px;
}

#datePicker {
  position: absolute;
  z-index: 1;
}

.table {
  position: relative;
  text-align: center !important;
}

.rdrDefinedRangesWrapper {
  background: #181821 !important;
  color: #9a9cab;
  border-right: solid 1px #9a9cab !important;
}

.rdrStaticRange {
  background: #181821 !important;
  color: #9a9cab;
  border-bottom: 1px solid #9a9cab !important;
}

.rdrCalendarWrapper,
.rdrInputRangeInput {
  background: #181821 !important;
}

.rdrMonthAndYearPickers select,
.rdrDayPassive .rdrDayNumber span {
  color: #9a9cab !important;
}

.rdrDayNumber span {
  color: #fff !important;
}

.rdrDateRangePickerWrapper {
  border: solid 1px #9a9cab !important;
}

.rdrStaticRange:hover .rdrStaticRangeLabel,
.rdrStaticRange:focus .rdrStaticRangeLabel {
  background: #1f1f2b !important;
}

.rdrNextPrevButton,
.rdrDateDisplayItem,
.rdrDateDisplayItem input {
  background: #fff !important;
  color: #000 !important;
}

.rdrDateDisplayItemActive {
  border-color: #fff !important;
}

.rdrDateDisplayWrapper {
  background-color: #1f1f2b !important;
}

.rdrDefinedRangesWrapper .rdrStaticRangeSelected {
  color: #ada6f2 !important;
}

.rdrDayEndOfMonth .rdrInRange,
.rdrDayEndOfMonth .rdrStartEdge,
.rdrDayEndOfWeek .rdrInRange,
.rdrDayEndOfWeek .rdrStartEdge,
.rdrStartEdge,
.rdrInRange,
.rdrEndEdge,
.rdrDayToday .rdrDayNumber span:after {
  background: #ada6f2 !important;
}

.rdrInputRangeInput {
  border: solid 1px #ada6f2 !important;
  color: #fff !important;
}

.rdrInputRangeInput:focus,
.rdrInputRangeInput:hover {
  border-color: #ada6f2;
  outline: 0;
  color: #fff !important;
}

.rdrDayEndOfMonth .rdrDayInPreview,
.rdrDayEndOfMonth .rdrDayStartPreview,
.rdrDayEndOfWeek .rdrDayInPreview,
.rdrDayEndOfWeek .rdrDayStartPreview {
  border-top-right-radius: 1.333em;
  border-bottom-right-radius: 1.333em;
  border-right-width: 1px;
  right: 0px;
  border-color: #ada6f2 !important;
}

.rdrDayStartOfMonth .rdrDayInPreview,
.rdrDayStartOfMonth .rdrDayEndPreview,
.rdrDayStartOfWeek .rdrDayInPreview,
.rdrDayStartOfWeek .rdrDayEndPreview {
  border-top-left-radius: 1.333em;
  border-bottom-left-radius: 1.333em;
  border-left-width: 1px;
  left: 0px;
  border-color: #ada6f2 !important;
}

.rdrDayEndPreview,
.rdrDayStartPreview {
  border-color: #ada6f2 !important;
}

.rdrDayInPreview {
  border-top-width: 1px;
  border-bottom-width: 1px;
  border-color: #ada6f2 !important;
}

.rdrYearPicker option,
.rdrMonthPicker option {
  background: #262635 !important;
}

.rdrYearPicker select::-webkit-scrollbar {
  height: 0px;
  /* height of horizontal scrollbar ← You're missing this */
  width: 4px;
  /* width of vertical scrollbar */
  border: 1px solid #d5d5d5;
}

.rdrYearPicker select::-webkit-scrollbar-track {
  background: #181821;
}

.rdrYearPicker select::-webkit-scrollbar-thumb {
  background: #262635;
}

.rdrDateDisplayItemActive {
  border: 3px solid #959595 !important;
}

.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
}

.styles-module_Editext__input__2-M50,
.styles-module_Editext__button__sxYQX {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  background-color: #181821 !important;
  color: #fff !important;
  border-color: #181821 !important;
}

.hiddenRow {
  padding: 0 !important;
}

.profile-header .profile-img img {
  object-fit: cover;
}

.makeStyles-navLink-1.active {
  font-size: 15px !important;
}

.accordion-toggle {
  border-top-width: 3px;
}

.daterangepicker,
.daterangepicker .calendar-table,
.daterangepicker td.off {
  color: #9a9cab;
  background-color: #1f1f2b !important;
  border: 1px solid #1f1f2b !important;
}

.daterangepicker td.active,
.daterangepicker td.in-range,
.daterangepicker td.available:hover,
.daterangepicker th.available:hover {
  background-color: #181821 !important;
  border-color: transparent;
  color: #9a9cab !important;
}

.applyBtn {
  background-color: #ada6f2 !important;
}

.cancelBtn {
  color: #9a9cab !important;
}

.calendar-table .prev span,
.daterangepicker .calendar-table .next span {
  color: #1f1f2b !important;
  border: solid #9a9cab !important;

  border-width: 0 2px 2px 0 !important;
  border-radius: 0 !important;
  display: inline-block !important;
  padding: 3px !important;
}

.daterangepicker.opensright:before,
.daterangepicker.opensright:after {
  left: 50% !important;
}

.daterangepicker:after,
.daterangepicker:before {
  border-bottom: 6px solid #1f1f2b !important;
}

.rdrDayDisabled {
  cursor: no-drop !important;
  background-color: #181821 !important;
  color: #9a9cab !important;
}

.rdrDayDisabled .rdrDayNumber {
  text-decoration: line-through !important;
  text-decoration-color: #9a9cab !important;
  text-decoration-thickness: 2px !important;
}
.rdrDayDisabled .rdrDayNumber span {
  color: #9a9cab !important;
}

.disabledBtn {
  background-color: #1f1f2b !important;
  color: #9a9cab !important;
}

.css-d7l1ni-option:active{
  color: #000 !important;
}

/* Pagination Baseline :- */

.css-pdct74-MuiTablePagination-selectLabel {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.43;
  letter-spacing: 0.01071em;
  flex-shrink: 0;
  color: #fff;
}

.css-levciy-MuiTablePagination-displayedRows {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.43;
  letter-spacing: 0.01071em;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  color: #fff;
  flex-shrink: 0;
}

.css-f3f49t-MuiSvgIcon-root-MuiNativeSelect-icon {
  -webkit-user-select: none;
  user-select: none;
  width: 1em;
  height: 1em;
  display: inline-block;
  flex-shrink: 0;
  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  fill: currentColor;
  font-size: 1.5rem;
  position: absolute;
  right: 0;
  top: calc(50% - .5em);
  pointer-events: none;
  background-color: #fff;
  /* color: rgba(0, 0, 0, 0.54); */
}

.css-16og44m-MuiToolbar-root-MuiTablePagination-toolbar {
  min-height: 52px;
  padding-right: 2px;
  align-items: baseline;
}



/* Navbar.css */
.page-sidebar {
  /* Add your sidebar styles here */
}



.nav-link {
  text-decoration: none;
  color: #000; /* Default color */
  display: flex;
  align-items: center;
  padding: 10px 15px;
}

.nav-link.active {
  color: #E85382 !important;
  font-weight: 500;
  font-size: 16px;
}

.nav-link.active span {
  color: #E85382 !important;
  font-weight: 900;
}

.sidenav__icon {
  margin-right: 10px;
}

.dropdown-icon {
  margin-left: auto; /* Align the dropdown icon to the right */
}


.pagination-root {
  flex-shrink: 0;
  margin-left: 20px; /* Adjust spacing as needed */
}

.btn-danger.custom-btn {
  border: none;
  border-radius: 4px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  padding-right: 10px;
}

`, "",{"version":3,"sources":["webpack://./src/assets/css/custom.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,yDAAyD;EACzD,UAAU;EACV,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yDAAyD;EACzD,UAAU;EACV,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yDAAyD;EACzD,UAAU;EACV,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yDAAyD;EACzD,UAAU;EACV,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,cAAc;EAId,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAIlB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yDAAyD;EACzD,UAAU;EACV,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,wBAAwB;EACxB,8BAA8B;EAC9B,SAAS;EACT,UAAU;EACV,yDAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EAEzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EAEvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,2CAA2C;AAC7C;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;;EAGE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,UAAU;EACV,sBAAsB;AACxB;;AAEA;;;;EAIE,gCAAgC;EAChC,mCAAmC;EACnC,uBAAuB;EACvB,UAAU;EACV,gCAAgC;AAClC;;AAEA;;;;EAIE,+BAA+B;EAC/B,kCAAkC;EAClC,sBAAsB;EACtB,SAAS;EACT,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,yDAAyD;EACzD,UAAU;EACV,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,4BAA4B;EAC5B,oCAAoC;EACpC,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;EACpC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,gCAAgC;;EAEhC,oCAAoC;EACpC,2BAA2B;EAC3B,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,yCAAyC;EACzC,yCAAyC;AAC3C;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,2BAA2B;;AAE3B;EACE,uDAAuD;EACvD,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EAGzB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,uDAAuD;EACvD,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,yBAAyB;EAGzB,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,qBAAqB;EAGrB,cAAc;EAEd,uDAAuD;EACvD,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;;;AAIA,eAAe;AACf;EACE,iCAAiC;AACnC;;;;AAIA;EACE,qBAAqB;EACrB,WAAW,EAAE,kBAAkB;EAC/B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB,EAAE,yCAAyC;AAC9D;;;AAGA;EACE,cAAc;EACd,iBAAiB,EAAE,6BAA6B;AAClD;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":["/* Write your custom CSS here */\r\n.MuiBackdrop-root {\r\n  background-color: rgba(0, 0, 0, 0.5) !important;\r\n}\r\n\r\n::-webkit-scrollbar {\r\n  height: 1px;\r\n  /* height of horizontal scrollbar ← You're missing this */\r\n  width: 8px;\r\n  /* width of vertical scrollbar */\r\n  border: 1px solid #d5d5d5;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: #181821;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: #e8538f;\r\n}\r\n\r\n.page-sidebar .accordion-menu::-webkit-scrollbar {\r\n  height: 0px;\r\n  /* height of horizontal scrollbar ← You're missing this */\r\n  width: 4px;\r\n  /* width of vertical scrollbar */\r\n  border: 1px solid #d5d5d5;\r\n}\r\n\r\n.collapse::-webkit-scrollbar {\r\n  height: 0px;\r\n  /* height of horizontal scrollbar ← You're missing this */\r\n  width: 2px;\r\n  /* width of vertical scrollbar */\r\n  border: 1px solid #d5d5d5;\r\n}\r\n\r\n.followDiv::-webkit-scrollbar {\r\n  height: 0px;\r\n  /* height of horizontal scrollbar ← You're missing this */\r\n  width: 3px;\r\n  /* width of vertical scrollbar */\r\n  border: 1px solid #d5d5d5;\r\n}\r\n\r\n.css-jtlhu6-MuiTablePagination-root {\r\n  overflow: auto;\r\n  color: white;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.image {\r\n  opacity: 1;\r\n  display: block;\r\n  width: 38%;\r\n  height: auto;\r\n  transition: 0.5s ease;\r\n  backface-visibility: hidden;\r\n}\r\n\r\n.middle {\r\n  transition: 0.5s ease;\r\n  opacity: 0;\r\n  position: absolute;\r\n  top: 55%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  -ms-transform: translate(-50%, -50%);\r\n  text-align: center;\r\n}\r\n\r\n.container:hover .image {\r\n  opacity: 0.6;\r\n  cursor: grab;\r\n}\r\n\r\n.container:hover .middle {\r\n  opacity: 1;\r\n}\r\n\r\n.page-sidebar .accordion-menu > li > span {\r\n  display: block;\r\n  color: #9a9cab;\r\n  -webkit-transition: all 0.1s ease-in-out;\r\n  -moz-transition: all 0.1s ease-in-out;\r\n  -o-transition: all 0.1s ease-in-out;\r\n  transition: all 0.1s ease-in-out;\r\n  line-height: 45px;\r\n  padding: 0 15px;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.page-sidebar .accordion-menu > li > span > svg {\r\n  width: 21px;\r\n  height: 21px;\r\n  line-height: 40px;\r\n  text-align: center;\r\n  vertical-align: text-top;\r\n  color: #9a9cab;\r\n  margin-right: 15px;\r\n  -webkit-transition: all 0.2s ease-in-out;\r\n  -moz-transition: all 0.2s ease-in-out;\r\n  -o-transition: all 0.2s ease-in-out;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.sidenav__icon {\r\n  margin-right: 15px;\r\n}\r\n\r\n.card-overflow {\r\n  overflow-x: scroll;\r\n}\r\n\r\n.card-overflow::-webkit-scrollbar {\r\n  height: 1px;\r\n  /* height of horizontal scrollbar ← You're missing this */\r\n  width: 3px;\r\n  /* width of vertical scrollbar */\r\n  border: 1px solid #d5d5d5;\r\n}\r\n\r\n.card-overflow::-webkit-scrollbar-track {\r\n  background: #181821;\r\n}\r\n\r\n.card-overflow::-webkit-scrollbar-thumb {\r\n  background: #1f1f2b;\r\n}\r\n\r\n.back__style {\r\n  width: \"100%\";\r\n  height: \"100%\";\r\n  background-size: \"cover\";\r\n  background-attachment: \"fixed\";\r\n  margin: 0;\r\n  padding: 0;\r\n  background-image: url(\"../images/login.png\");\r\n}\r\n\r\n.icon_margin {\r\n  margin-left: 5px;\r\n}\r\n\r\n.switch {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 58px;\r\n  height: 32px;\r\n}\r\n\r\n.switch input {\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.slider {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: #86c1ed;\r\n  -webkit-transition: 0.4s;\r\n  transition: 0.4s;\r\n}\r\n\r\n.slider:before {\r\n  position: absolute;\r\n  content: \"\";\r\n  height: 24px;\r\n  width: 24px;\r\n  left: 4px;\r\n  bottom: 4px;\r\n  background-color: white;\r\n  -webkit-transition: 0.4s;\r\n  transition: 0.4s;\r\n}\r\n\r\ninput:checked + .slider {\r\n  background-color: #ada6f2;\r\n}\r\n\r\ninput:focus + .slider {\r\n  box-shadow: 0 0 1px #ada6f2;\r\n}\r\n\r\ninput:checked + .slider:before {\r\n  -webkit-transform: translateX(26px);\r\n  -ms-transform: translateX(26px);\r\n  transform: translateX(26px);\r\n}\r\n\r\n.searchBar:focus {\r\n  background-color: #1f1f2b;\r\n  box-shadow: none;\r\n}\r\n\r\n.MuiTypography-colorInherit {\r\n  color: #91a3b0 !important;\r\n}\r\n\r\n.MuiSelect-select {\r\n  color: #91a3b0 !important;\r\n}\r\n\r\n.MuiSelect-icon {\r\n  color: #91a3b0 !important;\r\n}\r\n\r\n.MuiIconButton-root.Mui-disabled {\r\n  color: #9a9cab !important;\r\n}\r\n\r\n.MuiIconButton-root {\r\n  color: #86c1ed !important;\r\n}\r\n\r\n.float__right {\r\n  float: right;\r\n}\r\n\r\n.MuiPaper-root {\r\n  background-color: #161622 !important;\r\n}\r\n\r\n.text-gray {\r\n  color: #91a3b0;\r\n}\r\n\r\n.text-red {\r\n  color: #de1738;\r\n}\r\n\r\n.collapse-margin {\r\n  margin-left: -7px;\r\n  /* overflow-x: scroll; */\r\n}\r\n\r\n.pointer-cursor {\r\n  cursor: pointer;\r\n}\r\n\r\naudio::-webkit-media-controls-play-button,\r\naudio::-webkit-media-controls-panel {\r\n  background-color: aliceblue;\r\n  color: #fff;\r\n}\r\n\r\n.post-padding {\r\n  padding: 6px 15px !important;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.commentImg {\r\n  margin-top: 13px;\r\n}\r\n\r\n.shadow {\r\n  box-shadow: rgb(105 103 103 / 50%) 0px 5px 15px 0px;\r\n  border: 2px solid #e8538f;\r\n}\r\n\r\n.comment-delete {\r\n  margin-left: 10px;\r\n}\r\n\r\n.form-check-input:focus,\r\n.form-control:focus {\r\n  box-shadow: none;\r\n}\r\n\r\n.rows > * {\r\n  max-height: 500px;\r\n}\r\n\r\n.pie > * {\r\n  max-height: 350px;\r\n}\r\n\r\n.swal-title {\r\n  color: rgba(255, 255, 255, 0.65) !important;\r\n  font-weight: 500 !important;\r\n}\r\n\r\n.swal-text {\r\n  color: rgba(255, 255, 255, 0.64) !important;\r\n}\r\n\r\n.swal-modal {\r\n  background-color: #161622 !important;\r\n}\r\n\r\n.swal-icon--success__hide-corners,\r\n.swal-icon--success:after,\r\n.swal-icon--success:before {\r\n  background-color: transparent;\r\n}\r\n\r\n.MuiSelect-select:not([multiple]) option,\r\n.MuiSelect-select:not([multiple]) optgroup {\r\n  background-color: #161622 !important;\r\n}\r\n\r\n.chip,\r\n.highlightOption,\r\n.multiSelectContainer li:hover {\r\n  background: #e8538f !important;\r\n}\r\n\r\n.page-sidebar .accordion-menu {\r\n  overflow-x: scroll !important;\r\n}\r\n\r\n.danger {\r\n  background-color: #f5365c;\r\n}\r\n\r\n.success {\r\n  background-color: #146356;\r\n}\r\n\r\n.stats-card .stats-icon.change-pink {\r\n  color: #fff;\r\n  background-color: #fc9494;\r\n  box-shadow: 0 3px 18px -8px #fc9494;\r\n}\r\n\r\n.border-right-radius {\r\n  border-top-right-radius: 50rem;\r\n  border-bottom-right-radius: 50rem;\r\n}\r\n\r\n.pagination {\r\n  /* float: right; */\r\n}\r\n\r\n.page-link {\r\n  border-radius: 50% !important;\r\n  padding: 5px 13px;\r\n}\r\n\r\n.page-item {\r\n  padding: 5px;\r\n}\r\n\r\n.page-item.active .page-link {\r\n  z-index: 1;\r\n  color: #fff !important;\r\n  background-color: #e8538f;\r\n  border-color: #e8538f;\r\n}\r\n\r\n.page-link:focus {\r\n  box-shadow: none;\r\n}\r\n\r\n.dropdown {\r\n  max-height: 30px;\r\n  margin-top: 15px;\r\n  padding: 3px 5px;\r\n  font-size: 12px;\r\n  max-width: 80px;\r\n}\r\n\r\n#datePicker {\r\n  position: absolute;\r\n  z-index: 1;\r\n}\r\n\r\n.table {\r\n  position: relative;\r\n  text-align: center !important;\r\n}\r\n\r\n.rdrDefinedRangesWrapper {\r\n  background: #181821 !important;\r\n  color: #9a9cab;\r\n  border-right: solid 1px #9a9cab !important;\r\n}\r\n\r\n.rdrStaticRange {\r\n  background: #181821 !important;\r\n  color: #9a9cab;\r\n  border-bottom: 1px solid #9a9cab !important;\r\n}\r\n\r\n.rdrCalendarWrapper,\r\n.rdrInputRangeInput {\r\n  background: #181821 !important;\r\n}\r\n\r\n.rdrMonthAndYearPickers select,\r\n.rdrDayPassive .rdrDayNumber span {\r\n  color: #9a9cab !important;\r\n}\r\n\r\n.rdrDayNumber span {\r\n  color: #fff !important;\r\n}\r\n\r\n.rdrDateRangePickerWrapper {\r\n  border: solid 1px #9a9cab !important;\r\n}\r\n\r\n.rdrStaticRange:hover .rdrStaticRangeLabel,\r\n.rdrStaticRange:focus .rdrStaticRangeLabel {\r\n  background: #1f1f2b !important;\r\n}\r\n\r\n.rdrNextPrevButton,\r\n.rdrDateDisplayItem,\r\n.rdrDateDisplayItem input {\r\n  background: #fff !important;\r\n  color: #000 !important;\r\n}\r\n\r\n.rdrDateDisplayItemActive {\r\n  border-color: #fff !important;\r\n}\r\n\r\n.rdrDateDisplayWrapper {\r\n  background-color: #1f1f2b !important;\r\n}\r\n\r\n.rdrDefinedRangesWrapper .rdrStaticRangeSelected {\r\n  color: #ada6f2 !important;\r\n}\r\n\r\n.rdrDayEndOfMonth .rdrInRange,\r\n.rdrDayEndOfMonth .rdrStartEdge,\r\n.rdrDayEndOfWeek .rdrInRange,\r\n.rdrDayEndOfWeek .rdrStartEdge,\r\n.rdrStartEdge,\r\n.rdrInRange,\r\n.rdrEndEdge,\r\n.rdrDayToday .rdrDayNumber span:after {\r\n  background: #ada6f2 !important;\r\n}\r\n\r\n.rdrInputRangeInput {\r\n  border: solid 1px #ada6f2 !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.rdrInputRangeInput:focus,\r\n.rdrInputRangeInput:hover {\r\n  border-color: #ada6f2;\r\n  outline: 0;\r\n  color: #fff !important;\r\n}\r\n\r\n.rdrDayEndOfMonth .rdrDayInPreview,\r\n.rdrDayEndOfMonth .rdrDayStartPreview,\r\n.rdrDayEndOfWeek .rdrDayInPreview,\r\n.rdrDayEndOfWeek .rdrDayStartPreview {\r\n  border-top-right-radius: 1.333em;\r\n  border-bottom-right-radius: 1.333em;\r\n  border-right-width: 1px;\r\n  right: 0px;\r\n  border-color: #ada6f2 !important;\r\n}\r\n\r\n.rdrDayStartOfMonth .rdrDayInPreview,\r\n.rdrDayStartOfMonth .rdrDayEndPreview,\r\n.rdrDayStartOfWeek .rdrDayInPreview,\r\n.rdrDayStartOfWeek .rdrDayEndPreview {\r\n  border-top-left-radius: 1.333em;\r\n  border-bottom-left-radius: 1.333em;\r\n  border-left-width: 1px;\r\n  left: 0px;\r\n  border-color: #ada6f2 !important;\r\n}\r\n\r\n.rdrDayEndPreview,\r\n.rdrDayStartPreview {\r\n  border-color: #ada6f2 !important;\r\n}\r\n\r\n.rdrDayInPreview {\r\n  border-top-width: 1px;\r\n  border-bottom-width: 1px;\r\n  border-color: #ada6f2 !important;\r\n}\r\n\r\n.rdrYearPicker option,\r\n.rdrMonthPicker option {\r\n  background: #262635 !important;\r\n}\r\n\r\n.rdrYearPicker select::-webkit-scrollbar {\r\n  height: 0px;\r\n  /* height of horizontal scrollbar ← You're missing this */\r\n  width: 4px;\r\n  /* width of vertical scrollbar */\r\n  border: 1px solid #d5d5d5;\r\n}\r\n\r\n.rdrYearPicker select::-webkit-scrollbar-track {\r\n  background: #181821;\r\n}\r\n\r\n.rdrYearPicker select::-webkit-scrollbar-thumb {\r\n  background: #262635;\r\n}\r\n\r\n.rdrDateDisplayItemActive {\r\n  border: 3px solid #959595 !important;\r\n}\r\n\r\n.table-responsive {\r\n  display: block;\r\n  width: 100%;\r\n  overflow-x: auto;\r\n}\r\n\r\n.styles-module_Editext__input__2-M50,\r\n.styles-module_Editext__button__sxYQX {\r\n  padding-top: 0 !important;\r\n  padding-bottom: 0 !important;\r\n  background-color: #181821 !important;\r\n  color: #fff !important;\r\n  border-color: #181821 !important;\r\n}\r\n\r\n.hiddenRow {\r\n  padding: 0 !important;\r\n}\r\n\r\n.profile-header .profile-img img {\r\n  object-fit: cover;\r\n}\r\n\r\n.makeStyles-navLink-1.active {\r\n  font-size: 15px !important;\r\n}\r\n\r\n.accordion-toggle {\r\n  border-top-width: 3px;\r\n}\r\n\r\n.daterangepicker,\r\n.daterangepicker .calendar-table,\r\n.daterangepicker td.off {\r\n  color: #9a9cab;\r\n  background-color: #1f1f2b !important;\r\n  border: 1px solid #1f1f2b !important;\r\n}\r\n\r\n.daterangepicker td.active,\r\n.daterangepicker td.in-range,\r\n.daterangepicker td.available:hover,\r\n.daterangepicker th.available:hover {\r\n  background-color: #181821 !important;\r\n  border-color: transparent;\r\n  color: #9a9cab !important;\r\n}\r\n\r\n.applyBtn {\r\n  background-color: #ada6f2 !important;\r\n}\r\n\r\n.cancelBtn {\r\n  color: #9a9cab !important;\r\n}\r\n\r\n.calendar-table .prev span,\r\n.daterangepicker .calendar-table .next span {\r\n  color: #1f1f2b !important;\r\n  border: solid #9a9cab !important;\r\n\r\n  border-width: 0 2px 2px 0 !important;\r\n  border-radius: 0 !important;\r\n  display: inline-block !important;\r\n  padding: 3px !important;\r\n}\r\n\r\n.daterangepicker.opensright:before,\r\n.daterangepicker.opensright:after {\r\n  left: 50% !important;\r\n}\r\n\r\n.daterangepicker:after,\r\n.daterangepicker:before {\r\n  border-bottom: 6px solid #1f1f2b !important;\r\n}\r\n\r\n.rdrDayDisabled {\r\n  cursor: no-drop !important;\r\n  background-color: #181821 !important;\r\n  color: #9a9cab !important;\r\n}\r\n\r\n.rdrDayDisabled .rdrDayNumber {\r\n  text-decoration: line-through !important;\r\n  text-decoration-color: #9a9cab !important;\r\n  text-decoration-thickness: 2px !important;\r\n}\r\n.rdrDayDisabled .rdrDayNumber span {\r\n  color: #9a9cab !important;\r\n}\r\n\r\n.disabledBtn {\r\n  background-color: #1f1f2b !important;\r\n  color: #9a9cab !important;\r\n}\r\n\r\n.css-d7l1ni-option:active{\r\n  color: #000 !important;\r\n}\r\n\r\n/* Pagination Baseline :- */\r\n\r\n.css-pdct74-MuiTablePagination-selectLabel {\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  font-weight: 400;\r\n  font-size: 0.875rem;\r\n  line-height: 1.43;\r\n  letter-spacing: 0.01071em;\r\n  -webkit-flex-shrink: 0;\r\n  -ms-flex-negative: 0;\r\n  flex-shrink: 0;\r\n  color: #fff;\r\n}\r\n\r\n.css-levciy-MuiTablePagination-displayedRows {\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  font-weight: 400;\r\n  font-size: 0.875rem;\r\n  line-height: 1.43;\r\n  letter-spacing: 0.01071em;\r\n  -webkit-flex-shrink: 0;\r\n  -ms-flex-negative: 0;\r\n  color: #fff;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.css-f3f49t-MuiSvgIcon-root-MuiNativeSelect-icon {\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  width: 1em;\r\n  height: 1em;\r\n  display: inline-block;\r\n  -webkit-flex-shrink: 0;\r\n  -ms-flex-negative: 0;\r\n  flex-shrink: 0;\r\n  -webkit-transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\r\n  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\r\n  fill: currentColor;\r\n  font-size: 1.5rem;\r\n  position: absolute;\r\n  right: 0;\r\n  top: calc(50% - .5em);\r\n  pointer-events: none;\r\n  background-color: #fff;\r\n  /* color: rgba(0, 0, 0, 0.54); */\r\n}\r\n\r\n.css-16og44m-MuiToolbar-root-MuiTablePagination-toolbar {\r\n  min-height: 52px;\r\n  padding-right: 2px;\r\n  align-items: baseline;\r\n}\r\n\r\n\r\n\r\n/* Navbar.css */\r\n.page-sidebar {\r\n  /* Add your sidebar styles here */\r\n}\r\n\r\n\r\n\r\n.nav-link {\r\n  text-decoration: none;\r\n  color: #000; /* Default color */\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 10px 15px;\r\n}\r\n\r\n.nav-link.active {\r\n  color: #E85382 !important;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n}\r\n\r\n.nav-link.active span {\r\n  color: #E85382 !important;\r\n  font-weight: 900;\r\n}\r\n\r\n.sidenav__icon {\r\n  margin-right: 10px;\r\n}\r\n\r\n.dropdown-icon {\r\n  margin-left: auto; /* Align the dropdown icon to the right */\r\n}\r\n\r\n\r\n.pagination-root {\r\n  flex-shrink: 0;\r\n  margin-left: 20px; /* Adjust spacing as needed */\r\n}\r\n\r\n.btn-danger.custom-btn {\r\n  border: none;\r\n  border-radius: 4px;\r\n  padding-top: 5px;\r\n  padding-bottom: 5px;\r\n  padding-left: 10px;\r\n  padding-right: 10px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
